import { render, staticRenderFns } from "./backoffice-contratos.vue?vue&type=template&id=7366954d&scoped=true"
import script from "./backoffice-contratos.vue?vue&type=script&lang=ts"
export * from "./backoffice-contratos.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-contratos.vue?vue&type=style&index=0&id=7366954d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7366954d",
  null
  
)

export default component.exports